import { gql, useQuery } from '@apollo/client';
import { PiezoToolCall } from '../../../../client/piezo/signing/toolCalls';

export interface ListMetricsVars {
  domainIdentifier: string;
}

export interface ListMetricsData {
  listMetrics: {
    metrics: String[];
  };
}
const GQL_LIST_METRICS = gql`
  query getExternalCwMetrics($domainIdentifier: String!, $piezoArtifacts: JSON) {
    listMetrics(domainIdentifier: $domainIdentifier, piezoArtifacts: $piezoArtifacts)
  }
`;

export const useListCwMetrics = (vars: ListMetricsVars) => {
  const piezoToolCalls: PiezoToolCall[] = [
    {
      key: 'listMetrics',
      toolId: 'aes/domain/cw/list-cw-metrics',
      parameters: { domain_identifier: vars.domainIdentifier },
    },
  ];

  return useQuery<ListMetricsData, Record<string, unknown>>(GQL_LIST_METRICS, {
    variables: { ...vars },
    context: { piezoToolCalls },
  });
};
